// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"900ba4e9","223":"d4e2d099","355":"433737a6","453":"1aa225c0","977":"a95a937f"}[chunkId] + ".chunk.js";
};